import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

// import useSetupComplete from '@src/hooks/useSetupComplete';
import SetupLabelsScreen from '@src/screens/SetupLabels';
import SetupPrimeScreen from '@src/screens/SetupPrime';
import SetupTalentsScreen from '@src/screens/SetupTalents';
import SetupTravelingPreferenceScreen from '@src/screens/SetupTravelingPreference';
import SetupUserInfo from '@src/screens/SetupUserInfo';
import SetupUsernamePasswordScreen from '@src/screens/SetupUsernamePassword';

import { SetupRootStackParamList } from './types';

const Stack = createStackNavigator<SetupRootStackParamList>();

const Component: React.FC = () => {
  //const setupComplete = useSetupComplete();

  return (
    <Stack.Navigator
      headerMode="screen"
      screenOptions={{
        title: '',
      }}
      initialRouteName={'SetupUsernamePassword'}
    >
      <Stack.Screen
        name="SetupUsernamePassword"
        component={SetupUsernamePasswordScreen}
      />
      <Stack.Screen name="SetupTalents" component={SetupTalentsScreen} />
      <Stack.Screen name="SetupUserInfo" component={SetupUserInfo} />
      <Stack.Screen
        name="SetupTravelingPreference"
        component={SetupTravelingPreferenceScreen}
      />
      <Stack.Screen name="SetupLabels" component={SetupLabelsScreen} />
      <Stack.Screen name="SetupPrime" component={SetupPrimeScreen} />
    </Stack.Navigator>
  );
};

Component.displayName = 'SetupRootStack';

export default Component;
